import axios from "axios"
import router from "../router";
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

//ceshi
var BASE_URL = process.env.NODE_ENV === 'http://localhost:8083' //线上跨域，取消域名

// 创建基请求
const $http = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
    withCredentials: true
});

// 请求拦截器
$http.interceptors.request.use(config => {
    let token = sessionStorage.getItem('token')
    if (token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        config.headers.common['token'] = token
    }
    return config
}, err => {
    console.log(err)
})

//响应拦截器  处理错误
//$http.interceptors.response.use(con)

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function POST(url, params) {
    return $http.post(url, params, {
        headers: {
            'auth': 'application/x-www-form-urlencoded'
        }
    })
}
/**
 * post方法，对应formdata请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function FORMDATA(url, params) {
    return $http.post(url, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
/**
 * get方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} responseType [responseType]
 */
export function GET(url, params, responseType) {
    return $http.get(url, {
      params: params,
      responseType: responseType
    });
}
/**
 * get 获取  pdf 流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} responseType [responseType]
 */
export function GETPDF(url, params, responseType) {
    return $http.get(url, {
        params: params,
        responseType: responseType,
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    })
}
/**
 * post方法，对应post请求  上传文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function FILE(url, params) {
    return $http.post(url, params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 添加响应拦截器
$http.interceptors.response.use(function (res) {
    // var code = res.data.state;
    //console.log("data=recode=",res.data);
    // if (code == 10004) {
    //     console.log("10004")
    // }
    if(res.data.code == '1114'){ // 登录超时；
      router.app.$alert('登录超时或您还没有登录，请登录后操作', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          // 登录超时 清除缓存
          sessionStorage.setItem("token",'');
          sessionStorage.setItem("merchantInfo",'');
          sessionStorage.setItem("personInfo",'');
          sessionStorage.setItem("userInfo",'');

          window.location.href = '/#/logon';
          // router.app.$router.push("/logon");
        }
      });
    }
    /*else if(res.data.code != 0){ //请求错误提示
      router.app.$message.error(res.data.msg);
    }*/
    return res.data;
}, function (error) {
    var str = error.message;
    if (str.indexOf('Network Error') > -1) {
        // Toast('网络错误')
    } else if (str.indexOf('timeout') > -1) {
        // Toast('请求超时')
    } else {
        // Toast('服务器错误')
    }
    // 对响应错误做点什么
    return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/axios/axios.js